export enum AppTab {
  DASHBOARD = 'dashboard',
  IN_PROGRESS = 'freight-inprogress',
  FINISHED = 'freight-finished',
  MARKET = 'market',
  SHIP_PENDING = 'freight-ship-pending',
  SHIP_IN_PROGRESS = 'freight-ship-inprogress',
  SHIP_FINISHED = 'freight-ship-finished',
}
// TODO use this enum in tabs.routes.ts in shippers app.
